export default "__VITE_ASSET__DLnndtGp__"